function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { bem } from 'scripts/util';

/**
 * Component to toggle active state BEM classes,
 * instead of using show/hide methods
 * @TODO checkout using popstate for these to keep navigation hash
 */
var Toggler = /*#__PURE__*/function () {
  /**
   * Create a Toggler
   *
   * @param  {string} [block]     - Bem class identifier for group
   * @param  {string} [link]      - bEm class identifier for link togglers
   * @param  {string} [item]      - bEm class identifier for toggler targets
   * @param  {string} [activeMod] - beM class identifier for toggler/target active state
   * @return {void}
   */
  function Toggler() {
    var block = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'toggles';
    var link = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'link';
    var item = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'item';
    var activeMod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'active';
    _classCallCheck(this, Toggler);
    this.classes = {
      set: block,
      link: bem(block, link),
      linkActive: bem(block, link) + '--active',
      // bem adds non-modded class too
      item: bem(block, item),
      itemActive: bem(block, item) + '--active' // bem adds non-modded class too
    };
    this.sets = Array.from(document.querySelectorAll(".".concat(this.classes.set)));
    this.links = Array.from(document.querySelectorAll(".".concat(this.classes.link)));
    if (!this.domHasToggles()) return false;
    this.bindEventHandlers();
  }

  /**
   * Check to ensure we've found some toggleable elements
   *
   * @return {bool}
   */
  return _createClass(Toggler, [{
    key: "domHasToggles",
    value: function domHasToggles() {
      return this.sets && this.sets.length > 0 && this.links && this.links.length > 0;
    }

    /**
     * Register handlers for toggle items links
     *
     * @return {void}
     */
  }, {
    key: "bindEventHandlers",
    value: function bindEventHandlers() {
      var self = this;
      this.links.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          console.log(e.target);
          self.toggleItem(e.target);
        });
      });
    }

    /**
     * Toggle an link/item class based on constructor classes
     *
     * @param  {string} target - `#ID` for new active element
     * @return {void}
     */
  }, {
    key: "toggleItem",
    value: function toggleItem(targetLink) {
      var _this = this;
      var currentSet = targetLink.parentNode.parentNode;
      var links = Array.from(currentSet.getElementsByClassName(this.classes.link));
      var items = Array.from(currentSet.getElementsByClassName(this.classes.item));
      links.forEach(function (link) {
        return link.classList.remove(_this.classes.linkActive);
      });
      targetLink.classList.add(this.classes.linkActive);
      items.forEach(function (item) {
        return item.classList.remove(_this.classes.itemActive);
      });
      items.filter(function (item) {
        return "#".concat(item.id) === targetLink.hash;
      })[0].classList.add(this.classes.itemActive);
    }

    /**
     * Manually initiate the first item with the active class
     *
     * @param  {bool} [useUrlHash] - load initial url hash item
     * @return {void}
     */
  }, {
    key: "activateFirstItem",
    value: function activateFirstItem() {
      var _this2 = this;
      var useUrlHash = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (!this.domHasToggles()) return false;
      if (useUrlHash && window.location.hash) {
        var target = document.querySelector(window.location.hash);
        if (target.classList.contains(this.classes.item)) {
          this.toggleItem(window.location.hash);
        }
        return true;
      }
      this.sets.forEach(function (set) {
        _this2.toggleItem(set.children[0].children[0]);
      });
    }
  }]);
}();
export { Toggler as default };